import { useState } from 'react';
import { Collapse, List, ListItemButton, ListItemIcon, ListItemText, Typography, useTheme } from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { SubmenuProps } from '../SubMenus';
import { colors } from '../../../utils/palette';

const CustomListItem: React.FC<SubmenuProps & { closeFunction: () => void }> = ({
  buttonIcon,
  menuItems,
  buttonTitle,
  link,
  setSelectedMenu,
  closeFunction,
  selectedMenu,
}) => {
  const [open, setOpen] = useState(false);
  const theme = useTheme();

  const handleClick = () => {
    setOpen((prev) => !prev);
    if (link && !menuItems) {
      closeFunction();
      link();
      if (setSelectedMenu) setSelectedMenu({ main: buttonTitle });
    }
  };

  return (
    <>
      <ListItemButton
        onClick={handleClick}
        sx={{
          mt: 1.5,
          p: 1,
          backgroundColor: selectedMenu?.main === buttonTitle ? colors.lightSecondary : 'transparent',
          borderRadius: 2,
          '&:hover': {
            backgroundColor: selectedMenu?.main === buttonTitle ? colors.lightSecondary : 'transparent',
          },
        }}
        data-testid="customized-button"
      >
        <ListItemIcon sx={{ svg: { fill: selectedMenu?.main === buttonTitle ? theme.palette.primary.main : theme.palette.text.secondary } }}>
          {buttonIcon}
        </ListItemIcon>
        <ListItemText
          primary={<Typography sx={{ color: selectedMenu?.main === buttonTitle ? theme.palette.primary.main : 'inherit' }}>{buttonTitle}</Typography>}
        />
        {menuItems && menuItems.length > 0 && <>{open ? <ExpandLess /> : <ExpandMore />}</>}
      </ListItemButton>
      {menuItems && menuItems.length > 0 && (
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {menuItems?.map((item) => (
              <ListItemButton
                sx={{ borderLeft: `1px solid ${theme.palette.text.secondary}`, paddingLeft: '40px' }}
                key={item.title}
                onClick={() => {
                  item.link();
                  closeFunction();
                  if (setSelectedMenu) setSelectedMenu({ main: buttonTitle, child: item.title });
                }}
              >
                <ListItemText
                  primary={<Typography sx={{ color: selectedMenu?.child === item.title ? theme.palette.primary.main : 'inherit' }}>{item.title}</Typography>}
                />
              </ListItemButton>
            ))}
          </List>
        </Collapse>
      )}
    </>
  );
};

export default CustomListItem;
